import React from 'react';
import PropTypes from 'prop-types';

const Banner = ({ stageNumber, locale, message }) => (
  <span
    className={`banner stage-final__banner ${
      locale === 'en-US' && stageNumber === '12'
        ? 'banner--usOnly stage-final__banner--usOnly'
        : ''
    }`}
  >
    {message}
  </span>
);

Banner.propTypes = {
  message: PropTypes.string,
  stageNumber: PropTypes.string,
  locale: PropTypes.string,
};

export default Banner;
